import { Component, inject, signal } from '@angular/core';
import { form, FormField, maxLength, minLength, required } from '@angular/forms/signals';
import { AuthService } from '../../../services/auth-service';
import { NavigationHelper } from '../../../helpers/navigationHelper';
import { LoginData } from '../../../models/loginData';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login-page',
  imports: [FormField],
  templateUrl: './login-page.html',
  styleUrl: 'login-page.scss',
})
export class LoginPage {

  private authService = inject(AuthService);
  private navigationHelper = inject(NavigationHelper);
  private toastrService = inject(ToastrService);

  isLoading = signal(false);
  loginError = signal(false);

  loginModel = signal<LoginData>({
    username: '',
    password: '',
  });

  loginForm = form(this.loginModel, (schemaPath) => {
    required(schemaPath.username, { message: 'Username is required' });
    required(schemaPath.password, { message: 'Password is required' });
    minLength(schemaPath.password, 8, { message: 'Password must be at least 8 characters' });
    maxLength(schemaPath.password, 100, { message: 'Password is too long' });
  });

  login() {
    this.isLoading.set(true);
    let username = this.loginModel().username;
    let password = this.loginModel().password;
    this.authService.tryLogin(username.trim().toLowerCase(), password.trim()).then(({ success, redirectTo }) => {
      if (success) {
        this.loginError.set(false);
        this.isLoading.set(false);
        this.navigationHelper.navigateTo([redirectTo]);

      } else {
        this.loginError.set(true);
        this.isLoading.set(false);
        this.toastrService.error("Error de connexion");
      }
    }).catch(() => this.toastrService.error("Error de connexion"));
  }
}
